const TextWithPhoto = {};

export default TextWithPhoto